import React from 'react';

import Button from '@material-ui/core/Button';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Editor from '../QuillEditor/Editor';


const useStyles = makeStyles(theme => ({
    form: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        width: 900,
        maxWidth: '100%',
    },
    formButtons: {
        marginTop: theme.spacing(2)
    },
    textWrapper: {
        border: '1px solid #ddd',
        minHeight: 400,
        '& p': {
            marginBottom: 0,
            minHeight: '1rem'
        },
        '& .editor-wrapper': {
            padding: 5
        },
    },
}));

const UserBioForm = props => {
    const classes = useStyles();

    const {
        user
    } = props;

    const [showProgress, setShowProgress] = React.useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

    const [state, setState] = React.useState({
        officiant_bio: user.officiant_bio ? user.officiant_bio : '',
    });

    const submitForm = type => () => {
        let html = editorRef.current.value;
        if (html == '<p></p>' || html == '<p><strong></strong></p>') {
            html = '';
        }
        const formData = {
            _token: window._token,
            officiant_bio: html
        };
        new Promise((resolve, reject) => {
            const url = `/api/admin/users/${user.id}/bio`;
            setShowProgress(true);
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setShowSuccessMessage(true);
                })
                .catch(reason => {
                    alert('Please try again');
                })
                .finally(() => {
                    resolve();
                    setTimeout(() => {
                        setShowProgress(false);
                        if (type == 'save') {
                            window.location = '/admin/users';
                        }
                    }, 200);
                })
        });
    }

    const editorRef = React.createRef();

    return (
        <form className={classes.form}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <label htmlFor="user-bio">Officiant Bio</label>
                </Grid>
                <Grid item xs={12} className={classes.textWrapper}>
                    <Editor
                        initialValue={state.officiant_bio}
                        ref={editorRef}
                    />
                </Grid>
                <Grid item xs={12} className={classes.formButtons}>
                    <Box component="span">
                        <Button
                            variant="contained"
                            onClick={submitForm('continue')}
                            disabled={showProgress ? true : false}
                        >
                            Save & Continue Editing
                        </Button>
                        <Button
                            style={{marginLeft: 10}}
                            variant="contained"
                            color="primary"
                            onClick={submitForm('save')}
                            disabled={showProgress ? true : false}
                        >
                            Save
                        </Button>
                    </Box>
                    <Box component="span" ml={2}>
                        {showProgress === true && <CircularProgress size={20} />}
                        {showSuccessMessage === true && <Typography variant="overline" color="primary">Success!</Typography>}
                    </Box>
                </Grid>
            </Grid>
        </form>
    )
}

export default UserBioForm;
